// Mirrors the price lookup in functions/index.js (createCheckoutSession) —
// this copy is for display only; the Cloud Function always recomputes the
// real price server-side before creating a Stripe Checkout Session.

export function isEarlyBird(tournament) {
  if (!tournament || !tournament.earlyBirdCutoff) return false;
  return new Date() <= new Date(tournament.earlyBirdCutoff);
}

export function priceForGrade(tournament, grade) {
  var pricing = tournament && tournament.pricing && tournament.pricing[grade];
  if (!pricing) return null;
  return isEarlyBird(tournament) ? pricing.earlyBird : pricing.late;
}

// null/undefined maxEntries means unlimited. Returns null for "unlimited",
// otherwise the number of spaces left (never negative).
export function remainingForGrade(tournament, grade, enteredCount) {
  var max = tournament && tournament.maxEntries && tournament.maxEntries[grade];
  if (!max) return null;
  return Math.max(0, max - enteredCount);
}

export function formatPence(pence) {
  if (pence === null || pence === undefined) return "-";
  return "£" + (pence / 100).toFixed(2);
}

// Best-effort UK-biased normaliser for wa.me click-to-chat links.
// Strips everything but digits/leading +, then maps a leading 0 to +44.
export function normalizePhoneForWhatsApp(phone) {
  if (!phone) return null;
  var trimmed = phone.trim();
  var hasPlus = trimmed.charAt(0) === "+";
  var digits = trimmed.replace(/\D/g, "");
  if (hasPlus) return digits;
  if (digits.charAt(0) === "0") return "44" + digits.slice(1);
  return digits;
}

export function whatsAppLink(phone) {
  var normalized = normalizePhoneForWhatsApp(phone);
  return normalized ? "https://wa.me/" + normalized : null;
}
